export const hourMinute = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/; // [hour]:[minute]
export const multipleNumber = /^[\d;]+$/; // number and semi-colon (;)
export const multipleEmail = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,};?)+$/; // email and semi-colon (;)
export const hexColor = /(^#{0,1}[0-9A-F]{6}$)|(^#{0,1}[0-9A-F]{3}$)|(^#{0,1}[0-9A-F]{8}$)/i; // #ff1234 or ff1234
